import {Component, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {BnLoadingService, EntityPagedResult} from '@bndes/bndes-ux4/bndes-angular-utils';
import {MensagemService} from 'src/app/features/mensagem.service';
import {
  Estados,
  EstadosLista,
  QuestionarioAvaliacaoProjetoDTO,
  TIPO_FILTRAGEM_CAMPO,
  TIPO_ORDENACAO
} from 'src/app/model/questionario.model';
import {QuestionarioService} from 'src/app/questionario-fgenergia/questionario.service';
import Utils from 'src/app/shared/fgi-utils';
import {PermissaoService} from 'src/app/shared/permissao.service';

@Component({
    selector: 'app-questionario-fgenergia-pesquisa',
    templateUrl: './questionario-fgenergia-pesquisa.component.html',
    styleUrls: ['./questionario-fgenergia-pesquisa.component.scss'],
    standalone: false
})
export class QuestionarioFgenergiaPesquisaComponent implements OnInit{

  protected pesquisaForm: UntypedFormGroup;
  private pesquisado = false; // usado no html
  private valoresPesquisaForm: any;
  public questionarios: QuestionarioAvaliacaoProjetoDTO[];
  public atributosPaginacaoComponenteListagem: EntityPagedResult<QuestionarioAvaliacaoProjetoDTO>;
  private opcoesPaginacao: number[];
  private parametrosPesquisa: any = {};
  private totalObjetosRetornados: number;
  protected colunaOrdenacao: String;
  protected tipoOrdenacao: String;
  public opcoesTipoFiltragem = TIPO_FILTRAGEM_CAMPO;
  public opcoesTipoOrdenacao = TIPO_ORDENACAO;
  protected estados: Estados[] = EstadosLista;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private loadingService: BnLoadingService,
    private service: QuestionarioService,
    private permissaoService: PermissaoService,
    private mensagemService: MensagemService) {

  }


  ngOnInit() {
    //this.colunaOrdenacao = '1';   //buscar default ; colunaOrdenacao = 1 : CNPJ Cliente ; colunaOrdenação = 2 : Data aprovação
    //this.tipoOrdenacao = "asc";   //buscar default ; tipoOrdenacao = asc : Ascendente ; tipoOrdenacao = desc : Descendente
    this.valoresPesquisaForm = undefined;
    this.opcoesPaginacao = [10, 15, 20];
    this.atributosPaginacaoComponenteListagem = {
      page: 1,
      pageSize: this.opcoesPaginacao[0],
      pages: undefined,
      count: undefined,
      list: undefined
    };

    this.pesquisaForm = this.formBuilder.group({
      cnpjCliente: null,
      isEsco: null,
      ideRascunho: null,
      token: [{value: null} , [Validators.maxLength(36), Validators.pattern("^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$")]],
      dataAprovacao: null,
      ideEstado: null,

    });

    this.permissaoService.getPermissoesUsuarioAutenticado().subscribe((resp: any) => {
      this.construirFormulario();
    });

    this.buscar(false, false);  // renderiza lista automaticamente

  }


  private construirFormulario() {
    const valoresSessao = sessionStorage.getItem('valoresPesquisaQuestionarioForm');
    this.valoresPesquisaForm = valoresSessao ? JSON.parse(valoresSessao) : {};

    this.pesquisaForm.patchValue({
      isEsco: this.valoresPesquisaForm.isEsco ? this.valoresPesquisaForm.isEsco : null,
      dataAprovacao: this.valoresPesquisaForm.dataAprovacao ? new Date(this.valoresPesquisaForm.dataAprovacao) : null,
      cnpjCliente: this.valoresPesquisaForm.isEsco ? this.valoresPesquisaForm.isEsco : null,
      ideRascunho: this.valoresPesquisaForm.ideRascunho ? this.valoresPesquisaForm.ideRascunho : null,
      token: this.valoresPesquisaForm.token ? this.valoresPesquisaForm.token : null,
      ideEstado: this.valoresPesquisaForm.ideEstado ? this.valoresPesquisaForm.ideEstado : null,

    });

  }

  mudancaPagina(novaPagina: EntityPagedResult<QuestionarioAvaliacaoProjetoDTO>) {
    this.atributosPaginacaoComponenteListagem = novaPagina;
    this.buscar(false, false);
  }

  buscar(paginaVazia: boolean, voltarPagina1: boolean) {
    this.loadingService.bloqueiaTela();
    this.pesquisado = false;
    const params: any = {};

    const dataAprovacao = this.pesquisaForm.get('dataAprovacao').value;
    if (dataAprovacao) {
      params.dataAprovacao = dataAprovacao.cnpj;
    }

    const isEsco = this.pesquisaForm.get('isEsco').value;
    if (isEsco) {
      params.isEsco = isEsco;
    }

    const cnpjCliente = this.pesquisaForm.get('cnpjCliente').value;
    if (cnpjCliente) {
      params.cnpjCliente = cnpjCliente.trim();
    }

    const ideRascunho = this.pesquisaForm.get('ideRascunho').value;
    if (ideRascunho) {
      params.ideRascunho = ideRascunho.trim();
    }

    const token = this.pesquisaForm.get('token').value;
    if (token && token.trim()) {
      params.token = token.trim();
    }

    const ideEstado = this.pesquisaForm.get('ideEstado').value;
    if (ideEstado) {
      params.ideEstado = ideEstado;
    }

    this.parametrosPesquisa = JSON.parse(JSON.stringify(params));

    if (voltarPagina1) {
      this.atributosPaginacaoComponenteListagem.page = 1;
    }

    paginaVazia = Utils.verificaPaginaVazia(this.questionarios, this.atributosPaginacaoComponenteListagem, this.totalObjetosRetornados);
    if (paginaVazia && !voltarPagina1) {
      this.atributosPaginacaoComponenteListagem.page = this.atributosPaginacaoComponenteListagem.pages;
    }

    if(this.atributosPaginacaoComponenteListagem.page == undefined){
      this.atributosPaginacaoComponenteListagem.page = 1;
    }

    params.pagina = this.atributosPaginacaoComponenteListagem.page;
    params.limite = this.atributosPaginacaoComponenteListagem.pageSize;
    this.service.getQuestionariosAvaliacao(params)
      .subscribe(response => {
        this.questionarios = response ? response.resultados : undefined;
        this.atributosPaginacaoComponenteListagem.count = response ? response.totalRegistrosSemPaginacao : 0;
        this.totalObjetosRetornados = this.atributosPaginacaoComponenteListagem.count;
        this.pesquisado = true;
        this.loadingService.liberaTela();

        paginaVazia = Utils.verificaPaginaVazia(this.questionarios, this.atributosPaginacaoComponenteListagem, this.totalObjetosRetornados);
        if (paginaVazia && !voltarPagina1) {
          this.buscar(false, true);
        }

      });
  }

  limpar() {
    this.pesquisaForm.reset();
    this.ngOnInit();
  }

  public excluirQuestionario(idToken: any) {
    this.loadingService.bloqueiaTela();

    this.service.excluirQuestionario(idToken).subscribe((retorno) => {
      this.questionarios = this.questionarios.filter(q => q.id !== idToken);
      this.loadingService.liberaTela();
      this.mensagemService.adicionarMensagemSucesso("Questionário excluído com sucesso!");

    }, (error => {
      this.loadingService.liberaTela();
    }));
  }

}

